export const EDITOR_MODAL_MEDIA_UNSPLASH = 'EDITOR_MODAL_UNSPLASH_IMAGES_GIFS_STICKERS';
export const EDITOR_MODAL_SHAPE = 'EDITOR_MODAL_SHAPE';
export const EDITOR_MODAL_MEDIA_UPLOAD = 'EDITOR_MODAL_MEDIA_UPLOAD';
export const EDITOR_MODAL_TEMPLATES = 'EDITOR_MODAL_TEMPLATES';
export const EDITOR_MODAL_OUTLINK = 'EDITOR_MODAL_OUTLINK';
export const EDITOR_MODAL_HTML = 'EDITOR_MODAL_HTML';
